/* eslint-disable
    array-callback-return,
    no-prototype-builtins,
    no-unused-vars,
    no-useless-escape,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = [];

module.exports = angular.module('bench.ui.form.checkbox', deps).directive('blCheckbox', () => {
  let $$id = 0;

  return {
    restrict: 'E',
    template(elem, attrs) {
      const $id = $$id++;
      const id = `bl-checkbox-${$id}`;

      // set defaults
      _.defaults(attrs, {
        id,
        name: _.camelCase(attrs.legend),
        type: 'checkbox',
      });

      // attrs that go into input
      const inputAttrs = _(
        [
          'id',
          'name',
          'type',
          'ng-model',
          'ng-checked',
          'checked',
          'readonly',
          'ng-readonly',
          'ng-change',
          'ng-click',
          'ng-true-value',
          'ng-false-value',
        ].map(attr => {
          if (attrs.hasOwnProperty(_.camelCase(attr))) {
            const attrVal = attrs[_.camelCase(attr)];
            elem.removeAttr(attr);
            if (!_.isEmpty(attrVal)) {
              return `${attr}=\"${attrVal}\"`;
            }
            return attr;
          }
        }),
      )
        .compact()
        .join('\n');

      return `\
<input ${inputAttrs}>
<label for="${attrs.id}">
    <span class="bl-icon-checkmark bl-checkbox-checked">
    </span><span class="bl-checkbox-label" data-on="${attrs.on || 'on'}" data-off="${
        attrs.off || 'off'
      }""></span>
</label>
<span class="legend">${attrs.legend || ''}</span>\
`;
    },

    link(scope, elem, attrs) {
      // don't allow parent to have event handlers
      // they should be propagated to the input instead to allow native
      // html5 behaviour
      return elem.unbind();
    },
  };
});
